<template>
    <div class="p-0 mt-1">
        <v-card id="create">
            <v-speed-dial
                    v-model="fab"
                    :top="top"
                    :bottom="bottom"
                    :right="right"
                    :left="left"
                    :direction="direction"
                    :open-on-hover="hover"
                    :transition="transition"
            >

                <template v-slot:activator>
                    <v-btn
                            v-model="fab"
                            small
                            fab
                            icon>
                        <v-icon v-if="fab">mdi-close</v-icon>
                        <span v-else class="svg-icon svg-icon-dark svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes
                        .com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/../src/media/svg/icons/General/Other1.svg-->
                            <svg xmlns="http://www.w3.org/2000/svg"
                                 xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                                 height="24px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect x="0" y="0" width="24" height="24"/>
        <circle fill="#000000" cx="12" cy="5" r="2"/>
        <circle fill="#000000" cx="12" cy="12" r="2"/>
        <circle fill="#000000" cx="12" cy="19" r="2"/>
    </g>
</svg><!--end::Svg Icon--></span>
                    </v-btn>
                </template>
                <router-link :to="{name:'uploadCenter'}">
                    <v-btn
                            small
                            fab
                            title="افزودن به آپلود عکس"
                            class="btn-upload rounded-circle"
                    ><span class="svg-icon svg-icon-info svg-icon-2x"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/src/media/svg/icons/Design/Image.svg--><svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                            height="24px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24"/>
        <path
                d="M6,5 L18,5 C19.6568542,5 21,6.34314575 21,8 L21,17 C21,18.6568542 19.6568542,20 18,20 L6,20 C4.34314575,20 3,18.6568542 3,17 L3,8 C3,6.34314575 4.34314575,5 6,5 Z M5,17 L14,17 L9.5,11 L5,17 Z M16,14 C17.6568542,14 19,12.6568542 19,11 C19,9.34314575 17.6568542,8 16,8 C14.3431458,8 13,9.34314575 13,11 C13,12.6568542 14.3431458,14 16,14 Z"
                fill="#000000"/>
    </g>
</svg></span>
                    </v-btn>
                </router-link>
              <router-link :to="{name:'defaultText'}">
                  <v-btn
                          fab
                          small
                          title="افزودن متن پیشفرض"
                          class="btn-add-with-text rounded-circle"
                  >
                      <span class="fa fa-edit text-center" style="font-size: 1.3rem"></span>
                  </v-btn>
              </router-link>
            </v-speed-dial>
        </v-card>
    </div>
</template>

<script>
export default {
    name: "extraButtons",
    data: () => ({
        direction: 'right',
        fab: false,
        fling: false,
        hover: false,
        tabs: null,
        top: false,
        right: false,
        bottom: true,
        left: true,
        transition: 'slide-y-reverse-transition',
    }),

    watch: {
        top(val) {
            this.bottom = !val
        },
        right(val) {
            this.left = !val
        },
        bottom(val) {
            this.top = !val
        },
        left(val) {
            this.right = !val
        },
    },
}
</script>

<style>
/* This is for documentation purposes and will not be needed in your application */
#create .v-speed-dial {
    position: absolute;
}

#create .v-btn--floating {
    position: relative;
}
</style>